// The bpm MDS and Topography download menus offered EPS, not SVG, before the React port
// (bpm-mds-chart-template / bpm-tv-chart-template). The shared BASE_EXPORT_OPTIONS swapped
// EPS for SVG across every Highcharts chart; bpm keeps its original list instead.
export const BPM_EXPORT_OPTIONS = [
  { text: 'Download PNG image', key: 'png' },
  { text: 'Download JPEG image', key: 'jpeg' },
  { text: 'Download PDF document', key: 'pdf' },
  { text: 'Download EPS file', key: 'eps' }
]
